(() => {
  const sizes = ['30', '60', '120', '180'];

  const normalizePageSizeSelects = (root = document) => {
    const currentView = new URL(window.location.href).searchParams.get('view') || '';
    const viewSize = currentView.match(/(?:^|-)(60|120|180)$/)?.[1] || '30';

    root.querySelectorAll('select[data-results-per-page]').forEach((select) => {
      const selectedSize = sizes.includes(select.value) ? select.value : viewSize;
      select.replaceChildren(...sizes.map((size) => new Option(size, size, false, size === selectedSize)));
      select.value = selectedSize;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizePageSizeSelects(), { once: true });
  } else {
    normalizePageSizeSelects();
  }

  document.addEventListener('shopify:section:load', (event) => normalizePageSizeSelects(event.target));
  window.addEventListener('load', () => normalizePageSizeSelects(), { once: true });

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('select[data-results-per-page]');
    if (!select) return;

    event.stopImmediatePropagation();
    const size = select.value;
    const url = new URL(window.location.href);
    const currentView = url.searchParams.get('view') || '';
    const sizeSuffix = /-(?:20|30|50|60|100|120|180|200)$/;
    const isResultsSizeView = /^results-(?:20|30|50|60|100|120|180|200)$/;
    const declaredBase = select.dataset.resultsViewBase || '';
    const baseView = isResultsSizeView.test(declaredBase)
      ? ''
      : (declaredBase.replace(sizeSuffix, '') || (isResultsSizeView.test(currentView) ? '' : currentView.replace(sizeSuffix, '')));

    if (size === '30') {
      if (baseView) url.searchParams.set('view', baseView);
      else url.searchParams.delete('view');
    } else {
      url.searchParams.set('view', baseView ? `${baseView}-${size}` : `results-${size}`);
    }
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }, true);
})();
